import projects from '../../../assets/svg/projects.svg'
import projects_mouseover from '../../../assets/svg/projects_mouseover.svg'
import projects_selected from '../../../assets/svg/projects_selected.svg'
import { IMenuItem } from '../../../types/menuItems'

import dashboard from '../../../assets/svg/dashboard.svg'
import dashboard_mouseover from '../../../assets/svg/dashboard_mouseover.svg'
import dashboard_selected from '../../../assets/svg/dashboard_selected.svg'

import insights from '../../../assets/svg/insights.svg'
import insights_mouseover from '../../../assets/svg/insights_mouseover.svg'
import insights_selected from '../../../assets/svg/insights_selected.svg'

import accounting from '../../../assets/svg/accounting.svg'
import accounting_mouseover from '../../../assets/svg/accounting_mouseover.svg'
import accounting_selected from '../../../assets/svg/accounting_selected.svg'

import notification from '../../../assets/svg/notification.svg'
import notification_mouseover from '../../../assets/svg/notification_mouseover.svg'
import notification_selected from '../../../assets/svg/notification_selected.svg'

import timetracking from '../../../assets/svg/timetracking.svg'
import timetracking_mouseover from '../../../assets/svg/timetracking_mouseover.svg'
import timetracking_selected from '../../../assets/svg/timetracking_selected.svg'

// Budget icons - white for normal/hover, green for active
import budgeting from '../../../assets/svg/budgeting.svg'
import budgeting_mouseover from '../../../assets/svg/budgeting_mouseover.svg'
import budgeting_selected from '../../../assets/svg/budgeting_selected.svg'

export const insightsSubMenu: IMenuItem[] = [
  { name: 'Department Cost', path: '/insights', active: false, viewType: 'departmentCost', rights: [] },
  { name: 'Margin Trend Chart', path: '/insights', active: false, viewType: 'marginTrendChart', rights: [] },
  { name: 'Utilization Curve', path: '/insights', active: false, viewType: 'utilizationCurve', rights: [] },
  { name: 'Budget Phasing', path: '/insights', active: false, viewType: 'budgetPhasing', rights: [] },
  { name: 'Cost per Label', path: '/insights', active: false, viewType: 'costPerLabel', rights: [] },
  { name: 'Progress Chart', path: '/insights', active: false, viewType: 'progressChart', rights: [] },
  { name: 'Cost Forecast', path: '/insights', active: false, viewType: 'costForecast', rights: [] },
  { name: 'Invoice Status', path: '/insights', active: false, viewType: 'invoiceStatus', rights: [] },
]

export const projectSubMenuItems: IMenuItem[] = [
  { name: 'Dashboard', path: '/dashboard', parentPath: '/projects', active: false, rights: [6] },
  { name: 'Activities', path: '/activities', parentPath: '/projects', active: false, rights: [6] },
  { name: 'Budget', path: '/budget', parentPath: '/projects', active: false, rights: [16] },
  { name: 'Milestones', path: '/milestones', parentPath: '/projects', active: false, rights: [28] },
  {
    name: 'Insights',
    path: '/insights',
    parentPath: '/projects',
    active: false,
    submenu: insightsSubMenu,
    rights: [21],
  },
  { name: 'Accounting', path: '/accounting', parentPath: '/projects', active: false, rights: [19] },
  { name: 'Settings', path: '/settings', parentPath: '/projects', active: false, rights: [14] },
]

export const adminSubMenuItems: IMenuItem[] = [
  { name: 'User', path: '/user', parentPath: '/admin', active: false, rights: [2, 3, 4], disabled: false },
  { name: 'Rates', path: '/rates', parentPath: '/admin', active: false, rights: [5], disabled: false },
  { name: 'General', path: '/general', parentPath: '/admin', active: false, rights: [1], disabled: false },
]

export const globalMenu: IMenuItem[] = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    disabled: false,
    active: false,
    normalImg: dashboard_mouseover,
    activeImg: dashboard_selected,
    hoverImg: dashboard,
    rights: [27],
    featureKey: 'dashboard',
  },
  {
    name: 'User Dashboard',
    path: '/user-dashboard',
    disabled: false,
    active: false,
    normalImg: dashboard_mouseover,
    activeImg: dashboard_selected,
    hoverImg: dashboard,
    rights: [],
  },
  {
    name: 'Projects',
    path: '/projects',
    disabled: false,
    active: false,
    normalImg: projects_mouseover,
    activeImg: projects_selected,
    hoverImg: projects,
    rights: [6],
    featureKey: 'projects',
  },
  {
    name: 'Budget',
    path: '/budget',
    disabled: false,
    active: false,
    normalImg: budgeting_mouseover,
    activeImg: budgeting_selected,
    hoverImg: budgeting,
    rights: [29],
  },
  {
    name: 'Reports',
    path: '/reports',
    disabled: false,
    active: false,
    normalImg: insights_mouseover,
    activeImg: insights_selected,
    hoverImg: insights,
    rights: [24],
    featureKey: 'reports',
  },
  {
    name: 'Accounting',
    path: '/accounting',
    disabled: false,
    active: false,
    normalImg: accounting_mouseover,
    activeImg: accounting_selected,
    hoverImg: accounting,
    rights: [25, 26],
    featureKey: 'accounting',
  },
  {
    name: 'Time Tracking',
    path: '/time-tracking',
    disabled: false,
    active: false,
    normalImg: timetracking_mouseover,
    activeImg: timetracking_selected,
    hoverImg: timetracking,
    rights: [22],
    featureKey: 'time_tracking',
  },
  {
    name: 'Notification',
    path: '/notification',
    disabled: false,
    active: false,
    normalImg: notification_mouseover,
    activeImg: notification_selected,
    hoverImg: notification,
    rights: [],
    featureKey: 'notifications',
  },
]
